<template>
  <p-portfolio v-if="$hasPermission('portfolio.read')" />
  <p-not-found v-else />
</template>

<script>
import Pipelines from '@/components/pipelines/List.vue';
import NotFound from './../components/NotFound.vue';

export default {
  components: {
    'p-portfolio': Pipelines,
    'p-not-found': NotFound
  }
};
</script>
